// utils/createPageUrl.js

import i18n from '../i18n'; // 1. מייבאים את מופע ה-i18n שהגדרנו

/**
 * יוצר כתובת URL עם קידומת שפה (אופציונלית) ופרמטרים.
 * @param {string} pageName - שם העמוד/הנתיב (למשל, 'post', 'category').
 * @param {object} params - אובייקט של פרמטרים להוסיף ל-URL.
 * @returns {string} - כתובת ה-URL המלאה.
 */
export function createPageUrl(pageName, params = {}) {
  // 2. קוראים את השפה הנוכחית ישירות מהספרייה
  const lang = i18n.language;
  const defaultLang = 'he';

  // 3. יוצרים את קידומת השפה רק אם היא לא שפת ברירת המחדל
  const langPrefix = lang === defaultLang ? '' : `/${lang}`;

  // 4. בונים את מחרוזת הפרמטרים (נשאר כמו שהיה)
  const searchParams = new URLSearchParams(params).toString();
  const searchString = searchParams ? `?${searchParams}` : '';

  // 5. מחברים הכל יחד
  return `${langPrefix}/${pageName}${searchString}`;
}